import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import styles from './RTMNote.module.css';
import { CancelButton, CheckBox, DateField, LoadingIcon, SaveButton, ToolTipBulb } from '_components';

class PatientHomeAdmissionRTMNote extends React.Component {

    constructor() {
        super();
        this.handleRtmDetailsChange = this.handleRtmDetailsChange.bind(this);
        this.state = {
            rtmDetails: "",
            rtm98975Date: undefined,
            rtm98975: false,
            rtm98975Assist: false,
            rtm98977Date: undefined,
            rtm98977: false,
            rtm98980Date: undefined,
            rtm98980: false,
            rtm98980Assist: false,
            rtm98981Date: undefined,
            rtm98981: false,
            rtm98981Assist: false,

        };
    }

    handleRtmDetailsChange(event) {
        this.setState({
            rtmDetails: event.target.value,
        });
    }

    handle98975DateChange(val) {
        this.setState({ rtm98975Date: val });
    }

    click98975(val) {
        this.setState({ rtm98975: val ? val : false });
        if (!val) {
            this.setState({
                rtm98975Assist: false,
                rtm98975Date: null
            });
        }
    }

    click98975Assist(val) {
        this.setState({ rtm98975Assist: val ? val : false });
    }

    handle98977DateChange(val) {
        this.setState({ rtm98977Date: val });
    }

    click98977(val) {
        this.setState({ rtm98977: val ? val : false });
        if (!val) {
            this.setState({
                rtm98977Date: null
            });
        }
    }

    handle98980DateChange(val) {
        this.setState({ rtm98980Date: val });
    }

    click98980(val) {
        this.setState({ rtm98980: val ? val : false });
        if (!val) {
            this.setState({
                rtm98980Assist: false,
                rtm98980Date: null
            });
        }
    }

    click98980Assist(val) {
        this.setState({ rtm98980Assist: val ? val : false });
    }

    handle98981DateChange(val) {
        this.setState({ rtm98981Date: val });
    }

    click98981(val) {
        this.setState({ rtm98981: val ? val : false });
        if (!val) {
            this.setState({
                rtm98981Assist: false,
                rtm98981Date: null
            });
        }
    }

    click98981Assist(val) {
        this.setState({ rtm98981Assist: val ? val : false });
    }


    hasErrors() {
        // no rtmDetails
        if (!this.state.rtmDetails || !this.state.rtmDetails.trim()) {
            return true;
        }
        // must have at least one treatment box checked
        if (!this.state.rtm98975 && !this.state.rtm98977 && !this.state.rtm98980 && !this.state.rtm98981) {
            return true;
        }
        // if something checked, must have date
        if (
            (this.state.rtm98975 && !this.state.rtm98975Date)
            || (this.state.rtm98977 && !this.state.rtm98977Date)
            || (this.state.rtm98980 && !this.state.rtm98980Date)
            || (this.state.rtm98981 && !this.state.rtm98981Date)
        ) {
            return true;
        }

        return false;
    }


    saveRtmNote() {
        this.props.createRtmNote(
            this.props.epno,
            this.state.rtmDetails,
            this.state.rtm98975Date,
            this.state.rtm98975,
            this.state.rtm98975Assist,
            this.state.rtm98977Date,
            this.state.rtm98977,
            this.state.rtm98980Date,
            this.state.rtm98980,
            this.state.rtm98980Assist,
            this.state.rtm98981Date,
            this.state.rtm98981,
            this.state.rtm98981Assist
        );
    }


    renderErrors() {
        return (
            <div className={styles.error_wrapper}>
                {(!this.state.rtmDetails || !this.state.rtmDetails.trim()) &&
                    <li>You must specify the contents of the RTM Note</li>
                }
                {!this.state.rtm98975 && !this.state.rtm98977 && !this.state.rtm98980 && !this.state.rtm98981 &&
                    <li>You must specify at least one treatment code</li>
                }
                {this.state.rtm98975 && !this.state.rtm98975Date &&
                    <li>You must specify a treatment date for 98975</li>
                }
                {this.state.rtm98977 && !this.state.rtm98977Date &&
                    <li>You must specify a treatment date for 98977</li>
                }
                {this.state.rtm98980 && !this.state.rtm98980Date &&
                    <li>You must specify a treatment date for 98980</li>
                }
                {this.state.rtm98981 && !this.state.rtm98981Date &&
                    <li>You must specify a treatment date for 98981</li>
                }
            </div >
        );
    }



    render() {
        return (
            <div className={styles.rtm_note_wrapper}>
                <div className={styles.header}>Enter the RTM note details below:</div>
                <textarea name="rtmDetails" type="text" className={styles.rtm_details} rows="6" value={this.state.rtmDetails} onChange={this.handleRtmDetailsChange} />
                <div className={styles.header}>Select the applicable treatment codes below:</div>
                <div className={styles.treatment_table}>
                    <div className={styles.treatment_row}>
                        <span className={styles.treatment_dos}>
                            <DateField
                                date={this.state.rtm98975Date}
                                handleValueChange={(val) => this.handle98975DateChange(val)}
                                disabled={!this.state.rtm98975}
                            />
                        </span>
                        <span className={styles.treatment_code}>
                            <CheckBox
                                title={this.props.rtm98975ToolTip}
                                label='98975 - RTM Initial set-up (Onboarding)'
                                disabled={!this.props.rtm98975Billable || this.props.rtm98975PreviouslyBilled}
                                checked={this.state.rtm98975}
                                onClick={(val) => this.click98975(val)}
                            />
                        </span>
                        <span className={styles.treatment_assist}>
                            <CheckBox
                                label='Assistant contributed > 10%'
                                disabled={!this.state.rtm98975}
                                checked={this.state.rtm98975Assist}
                                onClick={(val) => this.click98975Assist(val)}
                            />
                        </span>
                        <span className={styles.lightbulb}>
                            <ToolTipBulb uid={'RTM_98975_' + this.props.epno} position='right' width={250} size='extra-small'>
                                <b>98975</b><br />
                                Remote therapeutic monitoring (e.g. respiratory system status, musculoskeletal
                                system status, therapy adherence, therapy response); initial set-up
                                and patient education on use of equipment
                            </ToolTipBulb >
                        </span>
                    </div>

                    <div className={styles.treatment_row}>
                        <span className={styles.treatment_dos}>
                            <DateField
                                date={this.state.rtm98977Date}
                                handleValueChange={(val) => this.handle98977DateChange(val)}
                                disabled={!this.state.rtm98977}
                            />
                        </span>
                        <span className={styles.treatment_code}>
                            <CheckBox
                                label='98977 - RTM Data Flow (Patient Activation + Monitoring Days)'
                                title={this.props.rtm98977Billable ? "" : "This treatment code is not supported by the patient's rate/treatment schedule."}
                                disabled={!this.props.rtm98977Billable}
                                checked={this.state.rtm98977}
                                onClick={(val) => this.click98977(val)}
                            />
                        </span>
                        <span className={styles.treatment_assist}>
                        </span>
                        <span className={styles.lightbulb}>
                            <ToolTipBulb uid={'RTM_98977_' + this.props.epno} position='right' width={250} size='extra-small'>
                                <b>98977</b><br />
                                RTM (e.g. respiratory system status, musculoskeletal system status,
                                therapy adherence, therapy response); device(s) supply with scheduled
                                (e.g. daily) recording(s) and/or programmed alert(s) transmission
                                to monitor musculoskeletal system, each 30 days
                            </ToolTipBulb >
                        </span>
                    </div>

                    <div className={styles.treatment_row}>
                        <span className={styles.treatment_dos}>
                            <DateField
                                date={this.state.rtm98980Date}
                                handleValueChange={(val) => this.handle98980DateChange(val)}
                                disabled={!this.state.rtm98980}
                            />
                        </span>
                        <span className={styles.treatment_code}>
                            <CheckBox
                                label="98980 - RTM Provider Minutes (Treatment/Call) 1st 20'"
                                title={this.props.rtm98980Billable ? "" : "This treatment code is not supported by the patient's rate/treatment schedule."}
                                disabled={!this.props.rtm98980Billable}
                                checked={this.state.rtm98980}
                                onClick={(val) => this.click98980(val)}
                            />
                        </span>
                        <span className={styles.treatment_assist}>
                            <CheckBox
                                label='Assistant contributed > 10%'
                                disabled={!this.state.rtm98980}
                                checked={this.state.rtm98980Assist}
                                onClick={(val) => this.click98980Assist(val)}
                            />
                        </span>
                        <span className={styles.lightbulb}>
                            <ToolTipBulb uid={'RTM_98980_' + this.props.epno} position='right' width={250} size='extra-small'>
                                <b>98980</b><br />
                                Treatment, physician/other QHCP time in a calendar month requiring
                                at least one interactive communication with the patient/caregiver
                                during the calendar month; first 20 minutes
                            </ToolTipBulb >
                        </span>
                    </div>

                    <div className={styles.treatment_row}>
                        <span className={styles.treatment_dos}>
                            <DateField
                                date={this.state.rtm98981Date}
                                handleValueChange={(val) => this.handle98981DateChange(val)}
                                disabled={!this.state.rtm98981}
                            />
                        </span>
                        <span className={styles.treatment_code}>
                            <CheckBox
                                label="98981 - RTM Provider Minutes (Treatment/Call) 2nd 20'"
                                title={this.props.rtm98981Billable ? "" : "This treatment code is not supported by the patient's rate/treatment schedule."}
                                disabled={!this.props.rtm98981Billable}
                                checked={this.state.rtm98981}
                                onClick={(val) => this.click98981(val)}
                            />
                        </span>
                        <span className={styles.treatment_assist}>
                            <CheckBox
                                label='Assistant contributed > 10%'
                                disabled={!this.state.rtm98981}
                                checked={this.state.rtm98981Assist}
                                onClick={(val) => this.click98981Assist(val)}
                            />
                        </span>
                        <span className={styles.lightbulb}>
                            <ToolTipBulb uid={'RTM_98981_' + this.props.epno} position='right' width={250} size='extra-small'>
                                <b>98981</b><br />
                                Remote therapeutic monitoring treatment, physician/other qualified
                                health care professional time in a calendar month requiring at least
                                one interactive communication with the patient/caregiver during the
                                calendar month; each additional 20 minutes
                            </ToolTipBulb >
                        </span>
                    </div>
                </div>

                {this.hasErrors() &&
                    <div>
                        {this.renderErrors()}
                    </div>
                }
                {!this.hasErrors() && !this.props.submitting &&
                    <div className={styles.button_wrapper}>
                        <span className={styles.button}><SaveButton onClick={() => this.saveRtmNote()} /></span>
                        <span className={styles.button}><CancelButton onClick={() => this.props.toggleVisibility({ epno: this.props.epno })} /></span>
                    </div>
                }
                {!this.hasErrors() && this.props.submitting &&
                    <div className={styles.button_wrapper}>
                        <span className={styles.button}><LoadingIcon /></span>
                    </div>
                }


            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(patientActions.toggleRtmVisibility, dispatch),
        createRtmNote: bindActionCreators(patientActions.createRtmNote, dispatch)

    };
}


function mapStateToProps(state, ownprops) {
    let ptno = state.entities.admissions[ownprops.epno].ptno;
    let discipline = state.entities.admissions[ownprops.epno].discipline;
    let submitting = state.ui.admissions[ownprops.epno].rtmSubmitting;

    let similarRtmAdmissions = Object.keys(state.entities.admissions)
        .filter(key => {
            return state.entities.admissions[key].ptno === ptno &&
                state.entities.admissions[key].discipline === discipline &&
                state.entities.admissions[key].isRTMEnabled;
        })
        .sort((a, b) => new Date(state.entities.admissions[b].startDate).getTime() - new Date(state.entities.admissions[a].startDate).getTime())
        .map(key => state.entities.admissions[key]);

    let rtm98975Billable = state.entities.admissions[ownprops.epno].rtm98975Billable;
    let rtm98977Billable = state.entities.admissions[ownprops.epno].rtm98977Billable;
    let rtm98980Billable = state.entities.admissions[ownprops.epno].rtm98980Billable;
    let rtm98981Billable = state.entities.admissions[ownprops.epno].rtm98981Billable;
    let rtm98975PreviouslyBilled = state.entities.admissions[ownprops.epno].rtm98975PreviouslyBilled;

    let rtm98975ToolTip = undefined;
    if (!rtm98975Billable) {
        rtm98975ToolTip = "This treatment code is not supported by the patient's rate/treatment schedule."
    } else if (rtm98975PreviouslyBilled) {
        rtm98975ToolTip = 'This patient has been previously billed for this code and can not be billed again.';
    }

    return {
        similarRtmAdmissions,
        rtm98975Billable,
        rtm98975PreviouslyBilled,
        rtm98977Billable,
        rtm98980Billable,
        rtm98981Billable,
        rtm98975ToolTip,
        submitting,

    };
}

const connectedPatientHomeAdmissionRTMNote = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionRTMNote);
export { connectedPatientHomeAdmissionRTMNote as PatientHomeAdmissionRTMNote };

